import React from 'react';
export function VisualMetaphor() {
  return <section className="mb-24" data-id="element-615">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-616">
        The Bricks and Mortar Revolution
      </h2>
      <p className="text-lg text-[#2C3E50] mb-6 font-['Inter']" data-id="element-617">
        Think of your skin like a house:
      </p>
      {/* First Image - Ceramides & Collagen Diagram */}
      <div className="mb-10" data-id="element-618">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gzFkFyGNXFk4FSaCdp8GoC/Skin_Youthful_2025_PDP_-_2.1.jpg" alt="Detailed diagram showing how ceramides act as mortar between skin cells while collagen provides structural strength" className="w-full rounded-lg shadow-md mb-4" data-id="element-619" />
        <p className="text-[14px] text-[#7F8C8D] text-center italic font-['Inter']" data-id="element-620">
          Ceramides form the "mortar" between skin cells, while collagen
          provides the structural "bricks"
        </p>
      </div>
      {/* Second Image - Split Screen Brick Wall */}
      <div className="mb-10" data-id="element-621">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8tzhzBGGCMzNkVv6CUteua/u8357357769_Split_screen_medical_illustration_of_skin_barrier_9e4209a3-cc60-4062-b352-600370aa0508_0.png" alt="Split screen comparison showing weak brick wall (left) versus strong reinforced brick wall (right)" className="w-full rounded-lg shadow-md mb-4" data-id="element-622" />
        <p className="text-[14px] text-[#7F8C8D] text-center italic font-['Inter']" data-id="element-623">
          Without ceramides (left), your skin barrier is weak and leaky. With
          ceramides (right), your skin forms a strong, protective barrier.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-8" data-id="element-624">
        <div className="flex flex-col" data-id="element-625">
          <div className="bg-[#FFE5D9] p-6 rounded-lg mb-4 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-626">
            <p className="font-semibold text-[#1B2951] mb-2 font-['Poppins']" data-id="element-627">
              Collagen = Bricks
            </p>
            <p className="text-[#2C3E50] font-['Inter']" data-id="element-628">
              (structure, firmness, support)
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300" data-id="element-629">
            <p className="font-semibold text-[#1B2951] mb-2 font-['Poppins']" data-id="element-630">
              Ceramides = Mortar
            </p>
            <p className="text-[#2C3E50] font-['Inter']" data-id="element-631">
              (locks everything in place, prevents moisture loss)
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300" data-id="element-632">
          <p className="text-lg text-[#2C3E50] text-center font-['Inter']" data-id="element-633">
            Most brands only give you bricks.
            <br data-id="element-634" />
            <span className="font-bold text-[#1B2951]" data-id="element-635">We give you both.</span>
          </p>
        </div>
      </div>
    </section>;
}